
export class UserPlanetEntitie {
    constructor({
        planetId,
        metal = 0,
        crystal = 0,
        deuterium = 0,
        metalMaxStorage = 10000,
        crystalMaxStorage = 10000,
        deuteriumMaxStorage = 10000,
        totalMetalPerHour = 0,
        totalCrystalPerHour = 0,
        totalDeuteriumPerHour = 0,
        totalMetalPerDay = 0,
        totalCrystalPerDay = 0,
        totalDeuteriumPerDay = 0,
        totalMetalPerWeek = 0,
        totalCrystalPerWeek = 0,
        totalDeuteriumPerWeek = 0,
        energyCost = 0,
        energyProduction = 0
    }) {
        this.planetId = planetId;
        this.metal = metal;
        this.crystal = crystal;
        this.deuterium = deuterium;
        this.metalMaxStorage = metalMaxStorage;
        this.crystalMaxStorage = crystalMaxStorage;
        this.deuteriumMaxStorage = deuteriumMaxStorage;
        this.totalMetalPerHour = totalMetalPerHour;
        this.totalCrystalPerHour = totalCrystalPerHour;
        this.totalDeuteriumPerHour = totalDeuteriumPerHour;
        this.totalMetalPerDay = totalMetalPerDay;
        this.totalCrystalPerDay = totalCrystalPerDay;
        this.totalDeuteriumPerDay = totalDeuteriumPerDay;
        this.totalMetalPerWeek = totalMetalPerWeek;
        this.totalCrystalPerWeek = totalCrystalPerWeek;
        this.totalDeuteriumPerWeek = totalDeuteriumPerWeek;
        this.energyCost = energyCost;
        this.energyProduction = energyProduction;
    }

    static fromJSON(json) {
        return new UserPlanetEntitie(json);
    }

    getTotalResources() {
        return {
            metal: this.metal,
            crystal: this.crystal,
            deuterium: this.deuterium
        };
    }

    getStorageUsage() {
        return {
            metalUsage: (this.metal / this.metalMaxStorage) * 100,
            crystalUsage: (this.crystal / this.crystalMaxStorage) * 100,
            deuteriumUsage: (this.deuterium / this.deuteriumMaxStorage) * 100
        };
    }

    getDailyIncome() {
        return {
            totalMetal: this.totalMetalPerDay,
            totalCrystal: this.totalCrystalPerDay,
            totalDeuterium: this.totalDeuteriumPerDay
        };
    }
}